import React, { forwardRef } from "react";
import { TextInput, TextInputProps } from "react-native";
import { fonts } from "../styles/theme";

// Drop-in replacement for RN's TextInput that defaults to the app's
// BarisSans font. Pass a style with fontFamily to override the weight.
const AppTextInput = forwardRef<TextInput, TextInputProps>(
  ({ style, ...props }, ref) => {
    return (
      <TextInput
        ref={ref}
        style={[{ fontFamily: fonts.regular }, style]}
        {...props}
      />
    );
  }
);

export default AppTextInput;
